// ============================================================================
// Global Application Configuration
// Single source of truth for port, type, and service-level constants
// ============================================================================

/** API port for all GenAI endpoints */
const PORT = 5045;

/** Product type identifier */
const TYPE = 'furniture';

/** Mediaflow userId mapped to the product type */
const MEDIA_USER_ID = '741208e1-946d-4d34-b829-d3cd72a35b5a';
const APPAREL_USER_ID = '741208e1-946d-4d34-b829-d3cd72a35b5a';

/** Base URLs resolved from environment */
const BASE_URL = import.meta.env.VITE_API_BASE_URL as string;
const MEDIAFLOW_BASE_URL = (import.meta.env.VITE_MEDIAFLOW_BASE_URL || 'https://mediaflow.snapmenu.ai') as string;

// ---------------------------------------------------------------------------
// Derived helpers (computed once, reused everywhere)
// ---------------------------------------------------------------------------

/** Port-prefixed base path: e.g. https://api.genaiembed.ai/p5013 */
const PORT_BASE = `${BASE_URL}/p${PORT}`;

// ---------------------------------------------------------------------------
// Export
// ---------------------------------------------------------------------------

export const APP_CONFIG = {
  PORT,
  TYPE,
  MEDIA_USER_ID,
  BASE_URL,
  MEDIAFLOW_BASE_URL,
  APPAREL_USER_ID,
  PORT_BASE,
} as const;

export default APP_CONFIG;
